import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ArrowRight, Handshake, TrendingUp, Award } from "lucide-react";

const BENEFITS = [
  { icon: TrendingUp, title: "High-Margin Franchise", desc: "Be part of India's fastest-growing clean-energy retail network." },
  { icon: Handshake, title: "Turn-Key Setup", desc: "End-to-end station build, branding, training and ongoing operations support." },
  { icon: Award, title: "Sector Leadership", desc: "Align with a brand investing across biofuel, EV and renewables." },
];

export default function Partner() {
  const navigate = useNavigate();

  function goToSection(id) {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }

    try {
      navigate("/");
    } catch (e) {
      try {
        window.location.hash = "#/";
      } catch (err) {}
    }

    setTimeout(() => {
      const el2 = document.getElementById(id);
      if (el2) el2.scrollIntoView({ behavior: "smooth", block: "start" });
    }, 300);
  }
  return (
    <section id="partner" data-testid="partner-section" className="relative py-28 md:py-36 overflow-hidden">
      <div className="partner-section-bg absolute inset-0 opacity-90" />

      <div
        className="partner-image-bg absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: "url(/generated/partner.png)",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10">
        <div className="partner-panel glass-card p-6 sm:p-8 md:p-12 lg:p-16 grain relative overflow-hidden">
          <div className="absolute -top-20 -right-20 w-80 h-80 rounded-full bg-eco-light opacity-20 blur-3xl" />
          <div className="absolute -bottom-16 -left-16 w-72 h-72 rounded-full bg-saffron opacity-15 blur-3xl" />

          <div className="relative grid lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-7 reveal">
              <span className="overline">Partnerships · Franchise · Investment</span>

              <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold mt-5 leading-[1.05] tracking-tight">
                <span className="text-saffron">Grow with India’s</span>
                <br />
                <span className="text-white">clean energy and</span>{" "}
                <span className="text-green-500">green future.</span>
              </h2>

              <p className="mt-7 text-white/70 text-base md:text-lg leading-relaxed max-w-2xl">
                We&apos;re inviting forward-thinking entrepreneurs, landowners and investors to join the network
                redefining how a billion people move and power their lives. Premium franchise opportunities
                are now open across Tier-1, Tier-2 and Tier-3 India.
              </p>

              <div className="mt-9 flex flex-wrap gap-4">
                <button onClick={() => goToSection("opportunities")} data-testid="partner-cta-primary" className="btn-saffron">
                  View Opportunities <ArrowRight className="w-4 h-4" />
                </button>
                <Link to="/enquiry" data-testid="partner-cta-secondary" className="btn-outline-green">
                  Start an Enquiry
                </Link>
              </div>
            </div>

            <div className="lg:col-span-5 space-y-4">
              {BENEFITS.map((b, i) => (
                <div
                  key={i}
                  className="partner-benefit reveal flex items-start gap-4 p-5 rounded-2xl border border-white/10 hover:border-eco-light/40 transition-all group"
                >
                  <div className="w-11 h-11 rounded-xl bg-eco-light/15 border border-eco-light/30 flex items-center justify-center shrink-0 group-hover:bg-eco-light/25 transition-all">
                    <b.icon className="w-5 h-5 text-eco-light" />
                  </div>
                  <div>
                    <div className="font-display font-semibold text-white">{b.title}</div>
                    <div className="text-sm text-white/55 mt-1">{b.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
}
